import { useMutation, useQueryClient } from "react-query";
import { Auth } from "../../interface";
import { mutatePutFn } from "../../services/networking.service";
import ENDPOINTS from "../../services/endPoints";

export const useToggleDeprecated = () => {
  const queryClient = useQueryClient();
  return useMutation<Auth, never, any>(
    (data) => mutatePutFn(ENDPOINTS.TOGGLE_DEPRECATED, data),
    {
      onSuccess: async () => {
        queryClient.invalidateQueries([ENDPOINTS.GET_PLANS]);
      },
    }
  );
};